import { Component, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AppTranslateService } from "src/app/core/service/app-translate.service";
import { AuthService } from "src/app/core/service/auth.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading: boolean = false;
  submitted: boolean = false;
  returnUrl: string;
  userName: any = {
    tittle: "Social-Security-Number",
    placeholder: "ÅÅMMDDNNNN",
  };

  @Input() cookie;

  public toAdminLogin: boolean = false;

  // <!-- Property declaration -->
  fieldTextType: boolean;

  // <!-- Switching method -->
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public toastr: ToastrService,
    private authService: AuthService,
    public appTranslate: AppTranslateService
  ) {}

  ngOnInit() {
    this.createForm();
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";

    this.toAdminLogin = false;
  }

  createForm() {
    this.loginForm = this.formBuilder.group({
      // username: ["", Validators.required],
      userName: ["", Validators.required],
      password: ["", Validators.required],
    });
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.authService
      .login(
        this.loginForm.controls.userName.value,
        this.loginForm.controls.password.value
      )
      .subscribe(
        (res) => {
          let data = res;
          if (this.appTranslate.currentLang() == "en") {
            const toaster = "Welcome " + data.firstName + "!";
            this.toastr.success(toaster, "Login Success", {
              timeOut: 2000,
            });
          } else {
            const toaster = "Välkommen " + data.firstName + "!";
            this.toastr.success(toaster, "Inloggning framgång", {
              timeOut: 2000,
            });
          }
          this.submitted = false;
          this.router.navigate(["/Home"]);
        },
        (err) => {
        }
      );
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  get userNameUpdValidation() {
    return this.loginForm.get("userName") as FormControl;
  }

  updateValidation(check) {
    if (check) {
      this.userNameUpdValidation.setValidators([
        Validators.required,
        Validators.email,
      ]);
    } else {
      this.userNameUpdValidation.setValidators([Validators.required]);
    }
    this.userNameUpdValidation.updateValueAndValidity();
  }

  // Only Integer Numbers
  public keyPressNumbers(event) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  actions(action: string, data?: any): void {
    switch (action) {
      case "AdminLogin":
        // this.loginTittle = "Admin-Login";
        this.toAdminLogin = true;
        this.submitted = true;
        this.submitted = false;
        this.userName.tittle = "Email-Id";
        this.userName.placeholder = "Email";
        this.updateValidation(this.toAdminLogin);
        this.loginForm.reset();
        break;
      case "ShareHoldersLogin":
        this.toAdminLogin = false;
        this.submitted = false;
        this.userName.tittle = "Social-Security-Number";
        this.userName.placeholder = "ÅÅMMDDNNNN";
        this.updateValidation(this.toAdminLogin);
        this.loginForm.reset();
        break;
      default:
        this.toAdminLogin = false;
        this.submitted = false;
        this.loginForm.reset();
    }
  }
}
